import { Controller } from "stimulus"
import { Turbo } from "@hotwired/turbo-rails"
import qs from 'qs'
import pickBy from 'lodash/pickBy';
import identity from 'lodash/identity';
import some from 'lodash/some';

export default class extends Controller {
  static targets = ['game', 'category', 'author', 'brand']

  refresh() {
    Turbo.visit(this.currentUrl())
  }

  gameChanged() {
    this.categoryTarget.value = null
    this.brandTarget.value = null
    this.authorTarget.value = null
    this.refresh()
  }

  categoryChanged() {
    this.brandTarget.value = null
    this.authorTarget.value = null
    this.refresh()
  }

  carBrandChanged() {
    this.authorTarget.value = null
    this.refresh()
  }

  currentUrl() {
    const gamePath = this.gameTarget.value ? `games/${this.gameTarget.value}` : null
    const baseUrl = [gamePath, 'downloads', this.categoryTarget.value, this.brandTarget.value].filter(identity).join('/')

    let params = pickBy({ author: this.authorTarget.value }, identity)
    return `/${baseUrl}${some(params) ? `?${qs.stringify(params)}` : ''}`
  }
}
